(function() {
	'use strict';

	angular.module('quantixApp').controller('UserListController',
			UserListController);

	UserListController.$inject = [ '$scope', '$http', 'UsageTrackerService',
			'$window','$timeout' ];

	function UserListController($scope, $http, UsageTrackerService, $window,$timeout) {
		var usageTrackerGrid = '';
		var userGrid = '';
		$scope.getUserListDetails = function() {

			UsageTrackerService.getUsersList().then(
					function(result) {

						for (var i = 0; i < result.length; i++) {

							if (result[i].isExternal == "Y"
									&& result[i].isInternal == "N") {

								result[i].typeOfUser = "External";
							} else {
								result[i].typeOfUser = "Internal";
							}

							if (result[i].accountNonExpired == true) {

								result[i].accountNonExpired = "Yes";
							} else {
								result[i].accountNonExpired = "No";
							}

						}

						$scope.userGrid = {

							dataProvider : result,
							delegate : $scope

						};

					});

		}

		$scope.userGridCompletion = function(event) {
			userGrid = event.target;
			userGrid.validateNow();
		}

		$scope.ipcheck = function(rowData, column) {

			var data = '';
			if (rowData.isIpCheck != null && rowData.isIpCheck == "Y") {
				data = '<span class="launchEditor" onClick="IpFlag(this)"><i class="fa fa-check usertraker-class"></i> </span>';
			} else if (rowData.isIpCheck == "N") {
				data = '<span class="launchEditor" onClick="IpFlag(this)"><i class="fa fa-remove usertraker-class2"></i> </span>';
			}
			return data;
		}
		$window.IpFlag = function(item) {
			
			$scope.actionMessage = {};
			$scope.itemData = item;
			if (item.parentNode.component.data.isIpCheck == "Y") {
				$scope.actionMessage.msg = "Do want to disable the IP check";
			} else {
				$scope.actionMessage.msg = "Do want to enable the IP check";
			}
			
			$timeout(function(){
				$('#myModalUserList').modal('show');
			},1000);
		}

		$scope.clickHere = function() {

			//var itemObj = $scope.itemData.parentNode.component.data;
			$scope.selectedItemdata = $scope.itemData.parentNode.component.data;
			var status = '';
			if ($scope.selectedItemdata.isIpCheck == "Y") {
				status = "N"
			} else {
				status = "Y"
			}
			$scope.updatestatusvalue($scope.selectedItemdata.id, status);

		}

		$scope.updatestatusvalue = function(id, status) {

			UsageTrackerService.IpcheckUpdate({
				id : id,
				isIpcheck : status
			}).then(function(result) {
				$scope.getUserListDetails();
			});
		}

		$scope.getUserListDetails();
	}

})();
